import { render, staticRenderFns } from "./modifyRecord.vue?vue&type=template&id=cf552a28&"
import script from "./modifyRecord.vue?vue&type=script&lang=js&"
export * from "./modifyRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports